import React, { useState, useEffect } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react'
import {Navigation, FreeMode, Scrollbar, A11y, Thumbs } from 'swiper/modules'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import Buy from '../../assets/img/banner-img/buy.png'
import Advisor from '../../assets/img/banner-img/advisor.png'
import Agent from '../../assets/img/banner-img/agent.png'
import JointVenture from '../../assets/img/banner-img/joint-venture.png'
import PreLease from '../../assets/img/banner-img/pre-lease.png'
import Project from '../../assets/img/banner-img/project.png'
import Rent from '../../assets/img/banner-img/rent.png'

export default function PropertyDreamBlock(){
    
    return (
        <section className='pb-5 pt-5 text-center HomepageBanner'>
            <div>
                <h1>Your Dream Property is Just a Click Away!</h1>
                <h5>Explore thousands of verified listings and find your perfect match today.</h5>

                <Swiper
                    loop={true}
                    navigation={true}
                    // slidesPerView= {7}
                    // spaceBetween={0}
                    centeredSlides={true}
                    modules={[Navigation, FreeMode]}
                    freeMode={true}
                    breakpoints={{
                        320: {
                          slidesPerView: 2,
                          spaceBetween: 10,
                        },
                        640: {
                          slidesPerView: 4,
                          spaceBetween: 10,
                        },
                        992: {
                          slidesPerView: 6,
                          spaceBetween: 10,
                        },
                        1300: {
                          slidesPerView:7,
                          spaceBetween:10,
                        },
                      }}
                    className='text-start cardBox mt-5'
                >
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={Buy}/></figure>
                                    <h5>Buy</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={Advisor}/></figure>
                                    <h5>Advisor</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={Agent}/></figure>
                                    <h5>Agent</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={JointVenture}/></figure>
                                    <h5>Joint Venture</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={PreLease}/></figure>
                                    <h5>Pre Lease</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={JointVenture}/></figure>
                                    <h5>Joint Venture</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={Project}/></figure>
                                    <h5>Project</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='headingBox shadowleft p-3 d-flex flex-column align-items-start justify-content-end ms-2 me-2 position-relative'>
                                    <figure><img src={Rent}/></figure>
                                    <h5>Rent</h5>
                                    <p>Unlock Your Dream Home</p>
                                    <a href="#" className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></a>
                                </div>
                            </SwiperSlide>
                </Swiper>
            </div>
        </section>
    )
}